import * as React from "react";
import CommonService from "../../../../services/common/common_read";
import MobileCreateService from "../../../../services/mobile/mobile_create";
import MobileReadService from "../../../../services/mobile/mobile_read";
import TransactionPopup from "../../../popups/transacrions/transaction_popup";
import uncheck from "../../../../../resource/img/checkbox/checkbox_unchecked_16.png";

export default class VillageConfig extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            village_config:[],
            village:{}
        }

        this.pullVillageByCode = this.pullVillageByCode.bind(this)
        this.saveVillage = this.saveVillage.bind(this)
        this.hideAddVillage = this.hideAddVillage.bind(this)
        this.loadVillageConfig = this.loadVillageConfig.bind(this)

        this.setVcSign = this.setVcSign.bind(this)
        this.setVeSign = this.setVeSign.bind(this)
    }

    componentDidMount() {

        console.log(this.props.data)

        this.loadVillageConfig()
        this.setTabAt(0)
    }

    toggleFilters(){
        let div = document.getElementById('div-filter')
        div.style.display = div.style.display === 'none'?'inherit':'none'
    }

    toggleCheck(i){

    }

    setTabAt(tab) {
        this.setState({tab: tab})
    }

    render() {
        return(<div style={{overflow:'hidden',height:'100%',marginRight:'16px'}}>

            <div className={'row'} style={{boxShadow:'0 4px 4px #aaa',padding:'8px 16px',backgroundColor:'#efefef'}}>
                <div className={'col col-sm-8'}>
                    <span className={'fa fa fa-bars'} style={{cursor:'pointer', marginTop:'8px'}} onClick={()=>this.toggleFilters()}/>
                    <input style={{width:'85%',marginLeft:'24px',backgroundColor:'#fff'}} placeholder={'Search here...'}/>
                    <span className={'fa fa fa-plus-circle'} style={{color:'darkcyan', float:'right',cursor:'pointer', margin:'8px'}} onClick={()=>this.toggleFilters()}/>
                </div>
                <div className={'col col-sm-4 fa-btn'}>
                    <button style={{float:'right',width:'80px'}} onClick={()=>TransactionPopup.dismiss()}>Close</button>
                    <button style={{float:'right',width:'80px'}} onClick={()=>this.loadData(0)} className={'refresh'}>Refresh</button>
                    <span className={'fa fa-check'} title={'Approve'} style={{color:'darkcyan', marginRight:'24px'}}/>
                    <span className={'fa fa-times'} title={'Reject'} style={{color:'#DF4A36'}}/>
                    <span className={'fa fa-pencil'} title={'Edit'}/>
                    {/*<span className={'fa fa-trash'} title={'Delete'} style={{color:'#DF4A36'}}/>*/}
                </div>

            </div>

            <div className={'col col-sm-9'} style={{border:'0.5px solid #ccc',display:'none'}} id={'div-filter'}>
                <br/>

                <table style={{width:'100%'}}>
                    <tbody>
                    <tr>
                        <td><label>{this.props.init_name} Reg Code : </label></td>
                        <td>
                            <input style={{width:'80%'}} type={'text'} id={'v_code'}/>
                            <span className={'fa fa-search'} title={'Search'} onClick={()=>this.pullVillageByCode()}
                                  style={{ marginRight:'8px',cursor:'pointer', fontSize:'20px',float:'right'}}/>
                        </td>
                    </tr>
                     <tr>
                        <td colSpan={2}>
                            <hr/>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <table style={{width:'100%',display:'none'}} id={'tb_more_village'}>
                    <tbody>
                        <tr>
                            <td style={{width:'30%'}}><label>{this.props.init_name} Name : </label></td>
                            <td>
                                {this.state.village.name}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td><label>{this.props.init_name==='Village'?'V.C Name':'Signatory 1 Name'} : </label></td>
                            <td><input id={'vc_name'} style={{width:'100%'}} type={'text'}/></td>
                        </tr>
                        <tr>
                            <td><label>Signature : </label></td>
                            <td><input onChange={(e)=>this.setVcSign(e)} id={'vc_sign'} style={{width:'100%'}} type={'file'}/></td>
                        </tr>
                        <tr>
                            <td><label>{this.props.init_name==='Village'?'V.E Name':'Signatory 2 Name'} :</label></td>
                            <td><input id={'ve_name'} style={{width:'100%'}} type={'text'}/></td>
                        </tr>
                        <tr>
                            <td><label>Signature : </label></td>
                            <td><input onChange={(e)=>this.setVeSign(e)} id={'ve_sign'} style={{width:'100%'}} type={'file'}/></td>
                        </tr>
                        <tr style={{display:this.props.init_name==='Village'?'table-row':'none'}}>
                            <td><label>Committee Date : </label></td>
                            <td><input id={'comm_date'} style={{width:'100%'}} type={'date'}/></td>
                        </tr>
                        <tr style={{display:this.props.init_name==='Village'?'table-row':'none'}}>
                            <td style={{verticalAlign:'top'}}><label>{this.props.init_name} Address : </label></td>
                            <td><textarea id={'v_address'} style={{width:'100%'}}/></td>
                        </tr>
                        <tr>
                            <td colSpan={'2'}>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={'2'}>
                                <button onClick={()=>this.saveVillage()}
                                    className={'default'} style={{float:'left' , width:'48%',marginRight:'1%'}}>Save</button>
                                <button onClick={()=>this.toggleFilters()} className={'default'} style={{float:'left', width:'48%'}}>Close</button>
                                <br/>

                            </td>
                        </tr>
                    </tbody>
                </table>

                <br/><br/>





            </div>

            <div className={'row'} style={{marginTop:'1vh'}}>
                <div className={'col col-sm-12'}>
                    <div className={this.state.tab===0?'tab tab-active':'tab'} onClick={()=>this.setTabAt(0)}>
                        <span className={'fa fa-list'}/> {this.props.init_name}s
                    </div>
                    {/*<div className={this.state.tab===1?'tab tab-active':'tab'} onClick={()=>this.setTabAt(1)}>
                        <span className={'fa fa-map'}/>
                    </div>*/}
                    {/*<div className={this.state.tab===2?'tab tab-active':'tab'} onClick={()=>this.setTabAt(2)}>
                        <span className={'fa fa-bar-chart'}/> Statistic
                    </div>*/}

                </div>
            </div>

            <div style={{width:'100%',height:'100%', overflow:'auto'}}>

                <table className={'tb'} style={{border:'1px solid #ccc',width:'98%',margin:'1%'}}>
                    <thead>
                    <tr>
                        <th style={{textAlign:'left',paddingLeft:'8px'}}>
                            <img id={'chk_0'} alt={'chk_0'} src={uncheck} onClick={()=>this.toggleCheck(0)}/>
                        </th>
                        <th>{this.props.init_name.toUpperCase()} NAME</th>
                        <th>CHAIRMAN NAME</th>
                        <th>EXECUTIVE NAME</th>
                        <th>COMMITTEE DATE</th>
                        <th>VILLAGE ADDRESS</th>
                        <th style={{textAlign:'right'}}>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.village_config.map((d,i)=>{
                        return(<tr key={i}>
                            <td>
                                <img id={'chk_'+i} alt={'chk_'+i}  style={{float:'left'}}
                                     src={uncheck} onClick={()=>this.toggleCheck(i)}/>
                                <span style={{float:'right'}}>
                                    {i+1}.
                                </span>
                            </td>
                            <td>{d.name}</td>
                            <td>{d.vc_name}</td>
                            <td>{d.ve_name}</td>
                            <td>{d.date}</td>
                            <td>{d.address}</td>
                            <td style={{textAlign:'right'}}>
                                <button style={{width:'50px'}} className={'default'}>Edit</button>
                                <button style={{width:'50px'}} className={'default'}>Delete</button>
                            </td>
                        </tr>)
                    })}
                    </tbody>
                </table>

            </div>

        </div>)

    }

    pullVillageByCode() {
        let v_code = document.getElementById('v_code').value.trim()
        if (v_code.length >0){
            CommonService.readDictionaryBy('locality','village','description',v_code).then(r=>{
                try {
                    if (r.data.results.length>0){
                        this.setState({
                            village:r.data.results[0]
                        })
                        document.getElementById('tb_more_village').style.display='inherit'
                    }else{
                        this.setState({
                            village: {
                                name:'Not Found'
                            }
                        })
                        document.getElementById('tb_more_village').style.display='none'
                    }
                }catch (e) {
                    console.log(e)
                }
            })
        }
    }

    hideAddVillage(){
        document.getElementById('vc_name').value = ""
        document.getElementById('ve_name').value = ""
        document.getElementById('comm_date').value = ""
        document.getElementById('v_address').value = ""
        this.toggleFilters()
    }

    saveVillage(){
        let vc_name = document.getElementById('vc_name').value
        let ve_name = document.getElementById('ve_name').value
        let comm_date = document.getElementById('comm_date').value
        let address = document.getElementById('v_address').value

        try {
            const formData = new FormData();
            formData.append('vc_sign', this.state.vc_sign);
            formData.append('ve_sign', this.state.ve_sign);
            formData.append('extra', JSON.stringify({
                project_id:this.props.data.ref_id,
                village_id:this.state.village.id,
                vc_name:vc_name,
                ve_name:ve_name,
                comm_date:comm_date,
                address:address
            }));

            MobileCreateService.configVillage(formData).then(r => {
                try {
                    if(r.data.status===1){
                        this.hideAddVillage()
                    }
                }catch (e) {
                    console.log(e)
                }
            })
        }catch (e) {
            console.log(e)
        }

    }

    setVeSign(e) { this.setState({ve_sign:e.target.files[0]})}
    setVcSign(e) { this.setState({vc_sign:e.target.files[0]})}

    loadVillageConfig(){
        try {
            MobileReadService.readVillageConfig(this.props.data.ref_id).then(r=>{
                try {
                    this.setState({
                        village_config:r.data.results
                    })
                }catch (e) {
                    console.log(e)
                }
            })
        }catch (e) {
            console.log(e)
        }
    }

}